import { MenuProps } from 'antd'
import styled from 'styled-components'

import { buildPassTheme } from 'src/styles/theme'

const Title = styled.span`
  ${({ theme }) => theme.font.label02}
  color: ${({ theme }) => theme.colour.secondary._500};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const dropdownTitle = (
  title: string,
  extra?: React.ReactNode
): MenuProps['items'][number] => ({
  key: `title-${title}`,
  label: (
    <Title>
      {title}
      {extra}
    </Title>
  ),
  style: {
    background: buildPassTheme.colour.secondary._50,
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
})
